import { mapActions, mapState } from 'vuex';
import ls from '@/helpers/localStorage';

export const SHOW_ODDS_KEY = 'odds-key';

export default {
  computed: {
    ...mapState('app', ['showOdds']),
    buttonText() {
      return this.showOdds ? 'Show Last Trade Price' : 'Show Implied Odds of Winning';
    },
  },
  methods: {
    ...mapActions('app', ['setShowOdds']),
    onShowOdds() {
      ls.set(SHOW_ODDS_KEY, true);
      this.setShowOdds(true);
    },
    onDontShowOdds() {
      ls.set(SHOW_ODDS_KEY, false);
      this.setShowOdds(false);
    },
    onToggle() {
      if (this.showOdds) {
        ls.set(SHOW_ODDS_KEY, false);
        this.setShowOdds(false);
      } else {
        ls.set(SHOW_ODDS_KEY, true);
        this.setShowOdds(true);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/price-odds-toggle-popup/price-odds-toggle-popup.js